import { DatePicker as AntdDatePicker, ConfigProvider } from 'antd'
import dayjs from 'dayjs'
import { Form } from 'react-bootstrap'

export default function DatePicker(props) {

    const {
        label_name,
        placeholder,
        name,
        value,
        minDate,
        maxDate,
        onChange,
        onBlur,
        error,
        mandatory,
        reference,
        tabIndex,
        disabled,
        picker,
        format = 'DD/MM/YYYY',
    } = props

    const compareUnit = picker === 'month' ? 'month' : 'day'

    return (
        <>
            <Form.Group className="mb-2" controlId={name}>
                {label_name === '' ? '' : <Form.Label className={mandatory ? 'form_label_red' : 'form_label'}>{`${label_name}${mandatory ? '*' : ''}`}</Form.Label>}
                <ConfigProvider
                    theme={{
                        components: {
                            DatePicker: {
                                activeShadow: '0 0 0 0.16rem rgba(0, 105, 114, 0.2)',
                                hoverBg: '#F6F3F5',
                                activeBg: '#F6F3F5',
                                zIndexPopup: '99999'
                            },
                        },
                        token: {
                            fontFamily: 'Inter'
                        },
                    }}
                >
                    <AntdDatePicker
                        ref={reference}
                        key={value || minDate || maxDate || picker || format}
                        className='form-control form_input'
                        placeholder={placeholder}
                        picker={picker}
                        format={format}
                        name={name}
                        disabled={disabled}
                        defaultValue={value ? dayjs(value, format) : ''}
                        disabledDate={(current) =>
                            (minDate && current && current.isBefore(dayjs(minDate, format), compareUnit))
                            || (maxDate && current && current.isAfter(dayjs(maxDate, format), compareUnit))
                        }
                        onChange={onChange}
                        onBlur={onBlur}
                        tabIndex={tabIndex}
                    />
                </ConfigProvider>
                {error}
            </Form.Group>
        </>
    )
}
